import React from 'react'
import { func, object, string, bool } from 'prop-types'
import PageFlow from '../../components/PageFlow'
import RegisterMFACompleteStep from '../../components/RegisterMFACompleteStep'
import {
  START_REGISTRATION,
  REGISTER,
  REGISTRATION_COMPLETE
} from '../../constants/mfa.setup.steps'
import { StartRegistrationStep, RegisterStep } from './steps'

class SetupMFAWebAuthn extends React.Component {
  finishRegistration = () =>
    this.props.onFinishRegistration({
      requestId: this.props.registrationData.requestId,
      credential: this.props.credential
    })

  render = () => {
    const { state: { isFromSettings } = {} } = this.props.location
    return (
      <PageFlow currentStep={this.props.step}>
        <PageFlow.Step name={START_REGISTRATION}>
          <StartRegistrationStep {...this.props} />
        </PageFlow.Step>
        <PageFlow.Step name={REGISTER}>
          <RegisterStep
            {...this.props}
            isValid={!!this.props.credential}
            onFinishRegistration={this.finishRegistration}
          />
        </PageFlow.Step>
        <PageFlow.Step name={REGISTRATION_COMPLETE}>
          <RegisterMFACompleteStep isFromSettings={isFromSettings} />
        </PageFlow.Step>
      </PageFlow>
    )
  }
}

SetupMFAWebAuthn.propTypes = {
  onPrepareRegistration: func.isRequired,
  onFinishRegistration: func.isRequired,
  onCancel: func.isRequired,
  location: object,
  isProcessing: bool,
  registrationData: object,
  credential: object,
  errorCode: string,
  step: string
}

SetupMFAWebAuthn.defaultProps = {
  location: { state: { isFromSettings: false } }
}

export default SetupMFAWebAuthn
